import { render, staticRenderFns } from "./BeneficiaryAutoTopups.vue?vue&type=template&id=58229ee8&scoped=true"
import script from "./BeneficiaryAutoTopups.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAutoTopups.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryAutoTopups.vue?vue&type=style&index=0&id=58229ee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58229ee8",
  null
  
)

export default component.exports